import { TOGGLE_HELPLY_COPILOT } from 'constants/action_types'

export function doToggleHelplyCopilot() {
  return {
    type: TOGGLE_HELPLY_COPILOT,
  }
}
